import React, { useState, useEffect, useRef } from 'react';

// [key-vault] DEV_KEY 不进代码：第一次打开面板时输入，存本设备；后端回 403 就清掉下次再问
function getDevKey() {
  var k = '';
  try { k = localStorage.getItem('aizhi_dev_key') || ''; } catch (e) {}
  if (!k) {
    k = String(window.prompt('\u8f93\u5165 .env \u91cc\u7684 DEV_KEY\uff08\u53ea\u95ee\u4e00\u6b21\uff09') || '').trim();
    if (k) { try { localStorage.setItem('aizhi_dev_key', k); } catch (e) {} }
  }
  return k;
}
var API_BASE = '/api/dev';

function api(method, endpoint, body) {
  var opts = { method: method, headers: { 'X-Dev-Key': getDevKey(), 'Content-Type': 'application/json' } };
  if (body) opts.body = JSON.stringify(body);
  return fetch(API_BASE + endpoint, opts).then(function(r) {
    if (r.status === 403) { try { localStorage.removeItem('aizhi_dev_key'); } catch (e) {} }
    return r.json();
  });
}

function EditorPanel({ onClose, theme }) {
  var isDark = theme === 'dark';
  var [tab, setTab] = useState('files');
  var [currentPath, setCurrentPath] = useState('/root/aizhi-backend/');
  var [files, setFiles] = useState([]);
  var [currentFile, setCurrentFile] = useState(null);
  var [code, setCode] = useState('');
  var [dirty, setDirty] = useState(false);
  var [saving, setSaving] = useState(false);
  var [termHistory, setTermHistory] = useState([{ type: 'out', text: 'aizhi terminal\n' }]);
  var [termCmd, setTermCmd] = useState('');
  var [deploying, setDeploying] = useState(false);
  var [deployLog, setDeployLog] = useState('');
  var [panelHeight, setPanelHeight] = useState(50);
  var termRef = useRef(null);
  var codeRef = useRef(null);
  var dragRef = useRef({ startY: 0, startH: 50, active: false });

  var accent = '#c4956a';
  var bg = isDark ? '#0d0d18' : '#f5f0ec';
  var cardBg = isDark ? '#12122a' : '#fff';
  var borderColor = isDark ? '#1e1e3a' : '#e0d8d0';
  var textPrimary = isDark ? '#d4c8b8' : '#2c2c2c';
  var textSecondary = isDark ? '#666' : '#888';

  var snapPoints = [40, 65, 95];

  function onDragStart(e) {
    var y = e.touches ? e.touches[0].clientY : e.clientY;
    dragRef.current = { startY: y, startH: panelHeight, active: true };
  }
  function onDragMove(e) {
    if (!dragRef.current.active) return;
    var y = e.touches ? e.touches[0].clientY : e.clientY;
    var diff = y - dragRef.current.startY;
    var newH = dragRef.current.startH + (diff / window.innerHeight) * 100;
    if (newH < 30) newH = 30;
    if (newH > 98) newH = 98;
    setPanelHeight(newH);
  }
  function onDragEnd() {
    if (!dragRef.current.active) return;
    dragRef.current.active = false;
    var closest = snapPoints[0];
    var minDist = Math.abs(panelHeight - closest);
    snapPoints.forEach(function(p) {
      var d = Math.abs(panelHeight - p);
      if (d < minDist) { minDist = d; closest = p; }
    });
    if (panelHeight < 25) { onClose(); return; }
    setPanelHeight(closest);
  }

  useEffect(function() { loadFiles(currentPath); }, []);

  function loadFiles(dir) {
    setCurrentPath(dir);
    api('GET', '/files?path=' + encodeURIComponent(dir)).then(function(data) {
      if (data.items) {
        var sorted = data.items.filter(function(f) {
          if (f.name === 'node_modules' || f.name === '.git' || f.name === 'build') return false;
          if (f.name.startsWith('.') && f.name !== '.env' && f.name !== '.gitignore') return false;
          return true;
        }).sort(function(a, b) {
          if (a.isDir && !b.isDir) return -1;
          if (!a.isDir && b.isDir) return 1;
          return a.name.localeCompare(b.name);
        });
        setFiles(sorted);
      }
    });
  }

  function openFile(filePath) {
    if (dirty && !true) return;
    api('GET', '/read?path=' + encodeURIComponent(filePath)).then(function(data) {
      if (data.content !== undefined) {
        setCurrentFile(filePath);
        setCode(data.content);
        setDirty(false);
      }
    });
  }

  function saveFile() {
    if (!currentFile) return;
    setSaving(true);
    api('POST', '/write', { path: currentFile, content: code }).then(function(data) {
      setSaving(false);
      setDirty(false);
    });
  }

  function runCommand() {
    if (!termCmd.trim()) return;
    var cmd = termCmd.trim();
    setTermCmd('');
    setTermHistory(function(h) { return h.concat([{ type: 'cmd', text: '$ ' + cmd }]); });
    api('POST', '/command', { command: cmd }).then(function(data) {
      var output = data.output || data.error || data.stderr || '(无输出)';
      setTermHistory(function(h) { return h.concat([{ type: data.error ? 'err' : 'out', text: output }]); });
      setTimeout(function() { if (termRef.current) termRef.current.scrollTop = termRef.current.scrollHeight; }, 50);
    });
  }

  function doDeploy(target) {
    setDeploying(true);
    setDeployLog('部署中...');
    api('POST', '/deploy', { target: target }).then(function(data) {
      var log = '';
      (data.results || []).forEach(function(r) {
        log += r.target + ': ' + (r.success ? '✅ 成功' : '❌ ' + (r.error || '失败')) + '\n';
      });
      setDeployLog(log);
      setDeploying(false);
    });
  }

  function pathUp() {
    var parts = currentPath.replace(/\/$/, '').split('/');
    parts.pop();
    var parent = parts.join('/') + '/';
    if (parent.length >= '/root/'.length) loadFiles(parent);
  }

  function formatSize(b) {
    if (b < 1024) return b + 'B';
    if (b < 1024 * 1024) return (b / 1024).toFixed(1) + 'K';
    return (b / 1024 / 1024).toFixed(1) + 'M';
  }

  return (
    <div style={{ position: 'fixed', inset: 0, zIndex: 9000, pointerEvents: 'none' }}>
      {/* 面板 */}
      <div style={{ position: 'absolute', top: 0, left: 0, right: 0, height: panelHeight + 'vh', background: bg, borderBottomLeftRadius: 16, borderBottomRightRadius: 16, display: 'flex', flexDirection: 'column', overflow: 'hidden', transition: dragRef.current.active ? 'none' : 'height 0.25s ease', boxShadow: '0 4px 20px rgba(0,0,0,0.3)', pointerEvents: 'auto' }}>
        {/* 顶栏 */}
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '10px 16px', borderBottom: '1px solid ' + borderColor, flexShrink: 0 }}>
          <span style={{ fontSize: 13, fontWeight: 600, color: accent, letterSpacing: 1 }}>DEV</span>
          <div style={{ display: 'flex', gap: 8 }}>
            <button onClick={function() { doDeploy('backend'); }} disabled={deploying} style={{ background: 'none', border: '1px solid ' + accent, color: accent, padding: '3px 10px', borderRadius: 6, fontSize: 11, cursor: 'pointer', fontFamily: 'inherit', opacity: deploying ? 0.4 : 1 }}>restart</button>
            <button onClick={onClose} style={{ background: 'none', border: 'none', color: textSecondary, fontSize: 20, cursor: 'pointer', padding: '0 4px' }}>×</button>
          </div>
        </div>

        {/* Tab栏 */}
        <div style={{ display: 'flex', borderBottom: '1px solid ' + borderColor, flexShrink: 0 }}>
          {['files', 'terminal'].map(function(t) {
            return (
              <div key={t} onClick={function() { setTab(t); }} style={{ padding: '8px 16px', fontSize: 12, cursor: 'pointer', color: tab === t ? accent : textSecondary, borderBottom: tab === t ? '2px solid ' + accent : '2px solid transparent', fontFamily: 'monospace' }}>
                {t === 'files' ? '文件' : '命令行'}
              </div>
            );
          })}
        </div>

        {/* 内容 */}
        <div style={{ flex: 1, overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>

          {/* 文件Tab */}
          {tab === 'files' && !currentFile && (
            <div style={{ flex: 1, overflow: 'auto' }}>
              {/* 路径切换 */}
              <div style={{ padding: '8px 12px', borderBottom: '1px solid ' + borderColor, display: 'flex', gap: 6, flexWrap: 'wrap', fontSize: 11, color: textSecondary }}>
                <span onClick={function() { loadFiles('/root/aizhi-backend/'); }} style={{ cursor: 'pointer', color: currentPath.startsWith('/root/aizhi-backend') ? accent : textSecondary }}>后端</span>
                <span>|</span>
                <span onClick={function() { loadFiles('/root/aizhi-frontend-git/'); }} style={{ cursor: 'pointer', color: currentPath.startsWith('/root/aizhi-frontend') ? accent : textSecondary }}>前端</span>
                <span style={{ marginLeft: 'auto', color: textSecondary, fontSize: 10 }}>{currentPath}</span>
              </div>
              {/* 上级目录 */}
              {currentPath !== '/root/aizhi-backend/' && currentPath !== '/var/www/aizhi/' && currentPath !== '/root/aizhi-frontend-git/' && (
                <div onClick={pathUp} style={{ padding: '10px 14px', cursor: 'pointer', color: textSecondary, fontSize: 12, borderBottom: '1px solid ' + borderColor }}>
                  📁 ..
                </div>
              )}
              {/* 文件列表 */}
              {files.map(function(f) {
                var fullPath = currentPath + f.name;
                return (
                  <div key={f.name} onClick={function() { f.isDir ? loadFiles(fullPath + '/') : openFile(fullPath); }} style={{ padding: '10px 14px', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 8, fontSize: 12, color: f.isDir ? '#8b9dc3' : textPrimary, borderBottom: '1px solid ' + borderColor + '44' }}>
                    <span style={{ width: 16 }}>{f.isDir ? '📁' : '📄'}</span>
                    <span style={{ flex: 1 }}>{f.name}</span>
                    {!f.isDir && <span style={{ fontSize: 10, color: textSecondary }}>{formatSize(f.size)}</span>}
                  </div>
                );
              })}
            </div>
          )}

          {/* 编辑器 */}
          {tab === 'files' && currentFile && (
            <div style={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
              <div style={{ padding: '6px 12px', borderBottom: '1px solid ' + borderColor, display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexShrink: 0 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                  <span onClick={function() { if (!dirty || true) { setCurrentFile(null); setCode(''); setDirty(false); } }} style={{ cursor: 'pointer', fontSize: 14, color: textSecondary }}>‹</span>
                  <span style={{ fontSize: 11, color: accent }}>{currentFile.split('/').pop()}{dirty ? ' •' : ''}</span>
                </div>
                <button onClick={saveFile} disabled={saving || !dirty} style={{ background: dirty ? accent + '22' : 'none', border: '1px solid ' + (dirty ? accent : borderColor), color: dirty ? accent : textSecondary, padding: '3px 12px', borderRadius: 6, fontSize: 11, cursor: dirty ? 'pointer' : 'default', fontFamily: 'inherit' }}>
                  {saving ? '...' : '保存'}
                </button>
              </div>
              <textarea ref={codeRef} value={code} onChange={function(e) { setCode(e.target.value); setDirty(true); }} spellCheck={false} style={{ flex: 1, background: isDark ? '#0a0a14' : '#faf8f5', color: textPrimary, border: 'none', padding: 12, fontFamily: "'SF Mono',Menlo,monospace", fontSize: 11, resize: 'none', outline: 'none', lineHeight: 1.6, tabSize: 2 }} onKeyDown={function(e) {
                if ((e.metaKey || e.ctrlKey) && e.key === 's') { e.preventDefault(); saveFile(); }
                if (e.key === 'Tab') { e.preventDefault(); var s = e.target.selectionStart; var end = e.target.selectionEnd; var val = code.substring(0, s) + '  ' + code.substring(end); setCode(val); setDirty(true); setTimeout(function() { codeRef.current.selectionStart = codeRef.current.selectionEnd = s + 2; }, 0); }
              }} />
            </div>
          )}

          {/* 命令行Tab */}
          {tab === 'terminal' && (
            <div style={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
              <div ref={termRef} style={{ flex: 1, overflow: 'auto', padding: 12, fontFamily: "'SF Mono',Menlo,monospace", fontSize: 11, lineHeight: 1.5, whiteSpace: 'pre-wrap', wordBreak: 'break-all' }}>
                {termHistory.map(function(h, i) {
                  var color = h.type === 'cmd' ? accent : h.type === 'err' ? '#ef4444' : textPrimary;
                  return <div key={i} style={{ color: color }}>{h.text}</div>;
                })}
              </div>
              <div style={{ display: 'flex', borderTop: '1px solid ' + borderColor, flexShrink: 0 }}>
                <span style={{ padding: '10px 12px', color: accent, fontFamily: 'monospace', fontSize: 12 }}>$</span>
                <input value={termCmd} onChange={function(e) { setTermCmd(e.target.value); }} onKeyDown={function(e) { if (e.key === 'Enter') runCommand(); }} placeholder="输入命令..." style={{ flex: 1, background: 'transparent', border: 'none', color: textPrimary, fontFamily: "'SF Mono',Menlo,monospace", fontSize: 12, outline: 'none', padding: '10px 0' }} />
              </div>
            </div>
          )}
        </div>

        {/* 部署日志 */}
        {deployLog && (
          <div style={{ padding: '8px 12px', borderTop: '1px solid ' + borderColor, fontSize: 11, color: textSecondary, fontFamily: 'monospace', whiteSpace: 'pre-wrap', maxHeight: 80, overflow: 'auto', flexShrink: 0 }}>
            {deployLog}
          </div>
        )}

        {/* 底部拖拽手柄 */}
        <div
          onTouchStart={onDragStart} onTouchMove={onDragMove} onTouchEnd={onDragEnd}
          onMouseDown={onDragStart} onMouseMove={onDragMove} onMouseUp={onDragEnd}
          style={{ padding: '6px 0 10px', cursor: 'grab', flexShrink: 0, touchAction: 'none', borderTop: '1px solid ' + borderColor }}
        >
          <div style={{ width: 36, height: 4, borderRadius: 2, background: isDark ? '#444' : '#ccc', margin: '0 auto' }} />
        </div>
      </div>
    </div>
  );
}

export default EditorPanel;